import React from "react"
import Image from "gatsby-image"
import styled from "styled-components"
import { Row, Col } from "react-bootstrap"
import vs from "../../images/meets/vs.png"
let SpeakersRowTwo = props => {
  return (
    <>
      <Row style={{ justifyContent: "center" }}>
        <Title>Speakers</Title>
      </Row>
      <DivSpeakers>
        <h2>Azure DevOps Team</h2>
      </DivSpeakers>
      <RowSpeakers className="row">
        <DivSpeakers className="col-xl-3 col-lg-6">
          <Image
            fluid={props.fluidSpeakerOne}
            alt={props.nameSpeakerOne}
          ></Image>
          <h4>{props.nameSpeakerOne}</h4>
          <p>{props.jobSpeakerOne}</p>
          <p>{props.companySpeakerOne}</p>
          <a href={props.linkSpeakerOne}>
            <Image
              fluid={props.LinkIcon}
              style={{
                width: "50px",
                margin: "auto",
                marginTop: "1rem",
              }}
              alt={props.nameSpeakerOne}
            ></Image>
          </a>
        </DivSpeakers>

        <DivSpeakers className="col-xl-3 col-lg-6">
          <Image
            fluid={props.fluidSpeakerTwo}
            alt={props.nameSpeakerTwo}
          ></Image>
          <h4>{props.nameSpeakerTwo}</h4>
          <p>{props.jobSpeakerTwo}</p>
          <p>{props.companySpeakerTwo}</p>
          <a href={props.linkSpeakerTwo}>
            <Image
              fluid={props.LinkIcon}
              style={{
                width: "50px",
                margin: "auto",
                marginTop: "1rem",
              }}
              alt={props.nameSpeakerTwo}
            ></Image>
          </a>
        </DivSpeakers>
      </RowSpeakers>
      <Row
        style={{
          justifyContent: "center",
          marginTop: "2rem",
          marginBottom: "2rem",
        }}
      >
        {/* <h1 style={{ fontSize: "3rem" }}>V/S</h1> */}
        <img src={vs} alt="vs" className="img-fluid"></img>
      </Row>
      <DivSpeakers>
        <h2>GitLab Team</h2>
      </DivSpeakers>
      <RowSpeakers className="row">
        <DivSpeakers className="col-xl-3 col-lg-6">
          <Image
            fluid={props.fluidSpeakerThree}
            alt={props.nameSpeakerThree}
          ></Image>
          <h4>{props.nameSpeakerThree}</h4>
          <p>{props.jobSpeakerThree}</p>
          <p>{props.companySpeakerThree}</p>
          <a href={props.linkSpeakerThree}>
            <Image
              fluid={props.LinkIcon}
              style={{
                width: "50px",
                margin: "auto",
                marginTop: "1rem",
              }}
              alt={props.nameSpeakerThree}
            ></Image>
          </a>
        </DivSpeakers>

        <DivSpeakers className="col-xl-3 col-lg-6">
          <Image
            fluid={props.fluidSpeakerFour}
            alt={props.nameSpeakerFour}
          ></Image>
          <h4>{props.nameSpeakerFour}</h4>
          <p>{props.jobSpeakerFour}</p>
          <p>{props.companySpeakerFour}</p>
          <a href={props.linkSpeakerFour}></a>
        </DivSpeakers>
        {props.nameSpeakerFive && (
          <DivSpeakers className="col-xl-3 col-lg-6">
            <Image
              fluid={props.fluidSpeakerFour}
              alt={props.nameSpeakerFour}
            ></Image>
            <h4>{props.nameSpeakerFour}</h4>
            <p>{props.jobSpeakerFour}</p>
            <p>{props.companySpeakerFour}</p>
            <a href={props.linkSpeakerFour}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerFour}
              ></Image>
            </a>
          </DivSpeakers>
        )}
        {props.nameSpeakerSix && (
          <DivSpeakers className="col-xl-3 col-lg-6">
            <Image
              fluid={props.fluidSpeakerFour}
              alt={props.nameSpeakerFour}
            ></Image>
            <h4>{props.nameSpeakerFour}</h4>
            <p>{props.jobSpeakerFour}</p>
            <p>{props.companySpeakerFour}</p>
            <a href={props.linkSpeakerFour}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerFour}
              ></Image>
            </a>
          </DivSpeakers>
        )}
      </RowSpeakers>
    </>
  )
}

export default SpeakersRowTwo

const RowSpeakers = styled.div`
  font-family: "Poppins", sans-serif;
  margin-left: auto;
  margin-right: auto;
  max-width: 80%;
  margin-top: 3rem;
  justify-content: center;
  text-align: center;
  @media (max-width: 400px) {
    margin-top: 1rem;
  }
`
const DivSpeakers = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  /*  margin-right: 2rem;
  margin-left: 2rem; */
  h4 {
    font-family: "Poppins", sans-serif;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  p {
    font-family: "Poppins", sans-serif;
    margin: 0;
    font-size: 1.2rem;
  }
`
const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
